import { Badge } from "@/components/ui/badge";
import { KeyRound, Tag } from "lucide-react";
import { cn } from "@/lib/utils";

export type ListingType = "rent" | "sale";

export const normalizeListingType = (value?: string | null): ListingType =>
  String(value || "sale").toLowerCase() === "rent" ? "rent" : "sale";

interface ListingTypeBadgeProps {
  listingType?: string | null;
  className?: string;
  showLabel?: boolean;
}

/**
 * Consistent rent/sale marker used across public and admin listing views.
 * Rent = key icon (secondary tone), Sale = tag icon (primary tone).
 */
export const ListingTypeBadge = ({ listingType, className, showLabel = true }: ListingTypeBadgeProps) => {
  const type = normalizeListingType(listingType);
  const isRent = type === "rent";
  const Icon = isRent ? KeyRound : Tag;

  return (
    <Badge
      className={cn(
        "gap-1 border",
        isRent
          ? "bg-accent text-accent-foreground border-accent"
          : "bg-primary text-primary-foreground border-primary",
        className
      )}
      aria-label={isRent ? "Rent" : "Sale"}
    >
      <Icon className="h-3 w-3" aria-hidden="true" />
      {showLabel && (isRent ? "Rent" : "Sale")}
    </Badge>
  );
};
